module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SpecialVideoPlayView.js"));
	}, "SpecialVideoPlayView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SpecialVideoPlayView!./src/pages/Shop/Home/Special/SpecialVideoPlay/SpecialVideoPlayView.js
// module id = 924
// module chunks = 431